import { render, staticRenderFns } from "./about.vue?vue&type=template&id=9a5fadb2&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports